import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-12 md:py-16 bg-warm-200" data-id="element-286">
      <div className="max-w-2xl mx-auto px-4 text-center" data-id="element-287">
        <div className="inline-flex items-center gap-2 bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-288">
          <AlertTriangle className="w-4 h-4" data-id="element-289" />
          <span data-id="element-290">Precio de Lanzamiento</span>
        </div>

        <p className="text-text-body mb-4" data-id="element-291">
          <strong className="text-primary-600 text-2xl" data-id="element-292">$29.999 COP</strong> es
          temporal. Después vuelve a{' '}
          <span className="line-through text-text-muted" data-id="element-293">$80.000 COP</span>.
        </p>

        <p className="text-text-dark font-medium" data-id="element-294">
          Cada noche sin un sistema es una noche que no recuperás.
        </p>
      </div>
    </section>;
}